export default __webpack_public_path__ + "images/AH.dae7c2f.png";